'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".SharingTruck-module_container__HOH-b{height:auto;vertical-align:middle;width:2rem;fill:#000}";
var styles = {"container":"SharingTruck-module_container__HOH-b"};
styleInject["default"](css_248z, 'ad20b37d-f457-4bc6-961e-985abcacc5fd');

exports["default"] = styles;
